export default {
  "privacyPage": {
    "title": "个人信息保护政策",
    "intro": [
      "广东省华晟育林科技有限公司（简称为“华晟育林”、“本网站”或“我们”）深知个人信息保护问题的重要性，并希望您了解我们在保护您个人信息及隐私上所做出的努力。请您务必要仔细阅读及理解本隐私政策，充分理解特别以粗体标识的条款，并作出相应选择。",
      "本个人信息保护政策将帮助您了解以下内容：",
      "个人信息保护政策适用范围；",
      "我们如何收集和/或使用您的个人信息；",
      "我们如何保护您的个人信息；",
      "您所拥有的个人信息权益；",
      "我们如何处理儿童的个人信息；",
      "您的个人信息将如何在全球范围转移；",
      "本个人信息保护政策如何更新",
      "您如何联系我们。"
    ],
    "sections": [
      {
        "title": "个人信息保护政策适用范围",
        "body": [
          "本个人信息保护政策适用于您在浏览和/或使用本网站，以及使用本网站特定功能时所提供的除匿名化信息之外的已识别或者可识别到自然人有关的各种信息（统称为“个人信息”）。为避免歧义，您需注意本个人信息保护政策不适用于以下方面：",
          "单独个人信息保护政策：针对向非华晟育林的第三方提供个人信息、公开处理个人信息、基于个人同意处理敏感个人信息和向境外提供个人信息，或者法律法规另有要求需要单独同意的情况下您可能需要与我们另行接受、同意和承诺该单独的个人信息保护政策。该等情形下的产品或服务以单独个人信息保护政策的实际内容为准，但如果该单独个人信息保护政策援引本政策或某些信息的收集和/或使用内容未能涵盖，请参照本个人信息保护政策以获得详细内容。",
          "任何第三方网站、链接或广告您在浏览网站期间，可能会作为本网站的一部分查看由第三方实际创建或提供的特定内容，还可能通过本网站的链接登录或访问第三方的网页、网址或广告。该网站可能会收集各种信息，还会使用Cookie和其他方式收集信息，但该等网站不受华晟育林托管，华晟育林并不对其任何行为或政策负责，您应当于第三方运营的网页或网址上查看该等第三方的相关隐私政策。"
        ]
      },
      {
        "title": "我们如何收集和/或使用您的个人信息",
        "body": [
          "您在浏览和/或使用网站过程中涉及的个人信息",
          "（1）您被动提供给我们的信息",
          "您在匿名的状态下即可访问本网站并浏览和/或获取信息。为实现网站的基本运营活动，大多数浏览器都会搜集某些必要的信息，这些信息包括：",
          "-网页浏览记录：我们的网页浏览量、访客数、平均访问的时长等",
          "-日志信息：与您使用本网站相关功能及浏览信息有关的网络请求信息、标准系统日志、错误故障信息、以及使用服务的活动时间等。",
          "- IP地址：您所使用的电脑IP是由互联网服务提供商(ISP)自动分配的。当您访问网站时，服务器会自动识别IP地址，并将其与访问时间；和访问页数一起记录。",
          "我们承诺使用该等信息的目的仅为网络日常运行，或提高网络运营质量，或对网站的使用率、管理、维护和帮助诊断服务器等问题提供参考。特别注意的是，单独的设备信息、日志信息是无法识别特定自然人身份的，因此不属于个人信息和个人敏感信息。但如果这类非个人信息与其他信息结合用于识别特定自然身份或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将被视为个人信息。一旦该情况发生，我们将履行法律法规所要求的告知或同意。",
          "（2）您主动提供给我们的个人信息",
          "您在使用本网站提供的特定服务或功能时，为使得该特定服务或功能得以按需求实现，您需要向我们提供个人信息。例如，如果您使用“咨询中心”的板块，您需要提供您的个人联系方式、姓名、邮箱、单位名称、留言内容；这些信息都是必要的，以供我们使用官方渠道与您联系。",
          "我们承诺使用该等信息的目的仅为实现上述特定服务或功能。如果您仅需要使用浏览、搜索等基本服务，您不需要提供上述信息。",
          "为确保信息的准确性和安全性，您应于本服务或功能的注册表单提供您本人真实、正确、最新及完整的资料，并及时更新登记资料，请确保其中不存在任何错误、不实、过时、不完整或具误导性的信息。如果您提供的信息中包含其他第三方的个人信息，在向华晟育林提供这些信息之前，您需确保您已获得第三方的合法同意或授权。",
          "一般情形下您无需提供的个人信息",
          "本网站并不要求您提供身份证、护照、驾驶证等法定证件信息，或者个人生物识别信息、个人财产信息、个人健康生理信息、宗教信仰、通讯记录、行踪轨迹等个人敏感信息。您应避免发送法定证件信息和个人敏感信息给予我们，或在发送该等信息时提示我们，以便我们对其履行法律要求的保护义务。如您被华晟育林员工要求提供前述信息，您可以随时通过本网站首页中的联系方式向我们反馈。",
          "收集和/或使用个人信息的合法事由",
          "根据中华人民共和国现行有效的法律法规，如满足以下任一情形，华晟育林收集和/或使用您的个人信息时无需取得同意：",
          "-与华晟育林履行所有可适用的有效法律法规规定的义务或职责相关的；",
          "-涉及国家安全、国防及国家秘密的；",
          "-为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；",
          "-为公共利益实施新闻报道、舆论监督等行为并在合理范围内处理个人信息；和履行合同约定所必需的，其中包括华晟育林为履行您所提出的需求，作为完成该需求的第一步，我们需要处理您的个人信息的情形。",
          "如涉及本政策“浏览和/或使用网站中涉及的个人信息”以外的个人信息收集和/或使用，根据中华人民共和国先行有效的法律法规，如满足以下任一情形，我们无需对使用目的、使用方式、信息种类等内容进行告知：",
          "-法律、行政法规规定应当保密或者不需要告知的情形；",
          "-紧急情况下为保护自然人的生命健康和财产安全无法及时向您告知的，该等情形下我们将在紧急情况消除后进行告知。",
          "根据现行有效的法律法规，如果我们对个人信息采取全面的技术措施和其他必要措施进行了去标识化处理，使得数据接收方无法重新识别特定个人且不能复原，则此类匿名化处理后的数据使用无需另行向您通知并征得您的同意。",
          "共享、转让、公开披露您的个人信息的规则",
          "（1）共享",
          "我们将采取合理的安全手段保护已存储的个人信息，在未得到您同意或进行告知之前，除非根据法律或政府的强制性规定或者基于前述合法事由，华晟育林不会将通过本网站收集的关于您的任何个人信息共享给任何无关的第三方（包括公司、组织和个人）；",
          "但本网站可能会在因善意确信这样的做法对于下列各项有其必要性，而共享个人信息：",
          "-您主动选择的共享在获得您的同意或者进行相关告知的情况下，依照同意/告知授权的范围与您指定的第三方进行共享，该情形不包含基于同意处理的个人敏感信息；",
          "- 与第三方服务供应商的共享：由于本网站由华晟育林授权的第三方服务供应商协助维护，在必要的范围内，我们可能向该等第三方服务供应商提供您的个人信息。在此情况下，我们将向您告知接收方的名称或姓名、联系方式、处理目的、处理方式和个人信息的种类，并取得您的单独同意。我们将尽合理之义务调查第三方信息安全能力并与之签订含有保密条款的合同。",
          "第三方服务提供商还可能以汇总的形式对单独的设备信息、日志信息（非个人信息）进行收集和/或统计，我们将以此统计信息了解浏览和/或使用本网站的人群情况，人群与网站交互情况，或浏览和/或使用本网站的一般趋势，例如统计国家或地区使用量的多少。该使用不会涉及对特定主体的识别和追踪。",
          "（2）转让",
          "本网站不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：",
          "- 在获取您的明确同意情况下转让；或",
          "- 在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。",
          "原则上本网站不会公开处理其收集的个人信息，但以下合法事由除外：",
          "- 取得您对公开披露的单独同意；",
          "- 为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；",
          "- 为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；",
          "- 法律、行政法规另有规定或者依法依规必须公开披露的其他情形。"
        ]
      },
      {
        "title": "我们如何保护您的个人信息",
        "body": [
          "1.网络安全防护措施",
          "为了个人信息遭到未经授权访问、网络攻击、披露、修改、损坏或类似风险，我们承诺已落实或将落实切实可行的安全防护措施，包括但不限于物理、技术和管理流程手段来保护在我们控制之下您的个人信息。例如，",
          "（1）我们使用加密功能如 Secure Socket Layer(SSL)协议，且提供 Hyper Text Transfer Protocol over Secure Socket Layer(HTTPS)的安全浏览模式；",
          "（2）您的个人信息全部被存储在安全加密的云端服务器上，并受到符合行业标准的防火墙系统的保护；",
          "（3）我们对您的个人信息设有专门且限定的访问控制权限，仅允许华晟育林特定人员进行必要情况下的查看或使用；",
          "（4）我们将依据重要性和敏感性对您的个人信息进行分类，并保证相应分类的收集、存储或使用具有对应的安全标准和等级；",
          "（5）我们将采取合理可行措施，确保未收集无关的个人信息。我们只会在达成本政策所述的目的和所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许；",
          "（6）对于信息安全系统如网络的运行状态，我们定期进行检查、监测和评估，识别可能发生的信息安全风险并采取相应措施；",
          "2.收集信息的最小化原则",
          "我们只会在达成本网站日常运行目的和本政策所述目的的所需期限内保留您的个人信息。在您的个人信息超出保留期后，我们会根据适用法律的要求删除您的个人信息或使之匿名化处理。当您从我们的服务中删除信息后，我们可能不会立即在备份系统中删除相应的信息，但会在备份更新时删除这些信息。",
          "3.安全事件",
          "互联网环境并非百分之百安全，我们将尽力确保或担保您的个人信息的安全性。如果发生或者可能发生个人信息泄露、篡改、丢失的，我们将立即采取补救措施，并按照法律法规要求通知履行个人信息保护职责的部门和个人。通知将包括下列事项：发生或者可能发生个人信息泄露、篡改、丢失的信息种类、原因和可能造成的危害；采取的补救措施和个人可以采取的减轻危害的措施；联系方式。我们强烈建议您使用安全加密的通信方式发送上述主动提供的个人信息。如果您发现您的个人信息发生泄露，请立即联络华晟育林，以便我们为您采取及时补救措施。"
        ]
      },
      {
        "title": "您所拥有的个人权益",
        "body": [
          "1.您可以行使的请求",
          "您有权要求访问、更正、删除、改变授权范围及约束信息系统决策在我们控制下的与您相关的任何个人信息（统称“请求”），请求权益列举如下。",
          "您可以通过联系 info@gdhsyl.com.cn来提出您的请求。为保证请求的可靠和安全，我们希望您以书面方式提出请求，并提供您的姓名、联系方式等必要信息以保证华晟育林能够验证您的身份，以确保请求人是个人信息主体或个人信息主体的合法代理人。",
          "（1）访问权",
          "您有权访问我们控制下的您的个人信息，除非法律法规另有规定。基于您的请求，只要不要求我们过多投入，我们将提供该等个人信息的相关记录或相关记录的副本。",
          "（2）更正权",
          "当您发现我们控制下的您的个人信息存在任何不准确或不完整之处，您有权要求我们在本个人信息保护政策收集及使用范围内作出更正。",
          "（3）删除权",
          "在以下情形中，您可以向我们提出删除个人信息的请求：",
          "- 如果我们处理个人信息的行为违反法律法规；",
          "- 如果我们收集、使用您的个人信息，却未征得您的同意；",
          "- 如果我们处理个人信息的行为违反了与您的约定；",
          "当您从我们的服务中删除信息后，我们可能不会立即在备份系统中删除相应的信息，但会在备份更新时删除这些信息。",
          "（4）获得个人信息副本",
          "您有权获取您的个人信息副本，在技术可行的前提下，如数据接口已匹配，我们还可按您的要求，直接将您的个人信息副本传输给您指定的第三方。",
          "（5）改变您授权同意的范围",
          "对于基于同意的个人信息的收集和使用，您可以随时给予或收回您的同意。当您收回同意后，我们将不再处理相应的个人信息。但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。",
          "对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情况收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。",
          "2.拒绝请求的情形",
          "在以下情形中，我们将无法响应您的请求：",
          "（1）与个人信息控制者履行法律法规规定的义务相关的；",
          "（2）与国家安全、国防安全直接相关的；",
          "（3）与公共安全、公共卫生、重大公共利益直接相关的；",
          "（4）与刑事侦查、起诉、审判和执行判决等直接相关的；",
          "（5）个人信息控制者有充分证据表明个人信息主体存在主观恶意或滥用权利的；",
          "（6）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到您的同意的；",
          "（7）响应您的请求将导致其他个人信息主体或其他个人、组织的合法权益受到严重损害的；",
          "（8）涉及商业秘密的。"
        ]
      },
      {
        "title": "我们如何处理儿童的个人信息",
        "body": [
          "本网站的服务主要面向成人，如果没有父母或监护人的同意，儿童不应主动提供个人信息。对于经父母同意而收集儿童个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护儿童所必需的情况下使用、共享、转让或公开披露此信息。如果我们发现儿童在未事先获得可证实的父母同意的情况下向我们提供了个人信息，我们将尽快删除相关个人信息。我们严格禁止儿童个人信息的违法复制、下载、或向第三方共享、转让或公开披露，除非受法律法规规定或强制措施。"
        ]
      },
      {
        "title": "个人信息保护政策的变更",
        "body": [
          "本网站可能对本个人信息保护政策不定期进行修改。对于重大变更，我们会提供给您显著的通知（包括对于某些服务，我们会通过电子邮件发送通知，说明个人信息保护政策的其变更的内容），本隐私政策所指的重大变更包括：",
          "我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；",
          "我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等，但企业上市及更名除外；",
          "个人信息共享、转让或公开披露的主要对象发生变化；",
          "您参与个人信息处理方面的权利及其行使方式发生重大变化；",
          "我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；",
          "个人信息安全影响评估报告表明存在高风险时。我们还会将本政策的旧版本存档，供您查阅。",
          "如果在本个人信息保护政策任何修改发布后，您继续使用本网站，则表示您同意遵守任何该等修改。"
        ]
      },
      {
        "title": "您如何联系我们",
        "body": [
          "如果您有任何疑问，或者有任何建议，请通过以下方式联系我们：",
          "如您有任何问题，意见或建议，或您要求我们需要改善的地方，或您发现个人信息可能被泄露或认为华晟育林违反了法律法规或有关个人信息的收集或使用方式，您可以由书面形式发送邮件至 info@gdhsyl.com.cn和通讯办公地址，珠海市高新区湾创路88号A栋406与我们联系，我们将在 30 个自然日内给出答复。"
        ]
      }
    ]
  },
  "copyrightPage": {
    "title": "版权声明",
    "intro": [],
    "sections": [
      {
        "title": "一、权属界定",
        "body": [
          "广东省华晟育林科技有限公司（以下简称 “本公司”），系本公司全部公开发行心理测评量表产品在中华人民共和国境内唯一独家知识产权权利人。 本公司全面负责全系列测评量表原版引进、本土化修订、常模数据研发、标准化配套资料编撰、线上测评系统开发及全国范围内发行运营工作。量表全部文本条目、计分规则、常模数据库、操作指导手册、电子测评程序、配套培训材料等全部衍生内容，著作权、专有运营许可权、商品化权利均归本公司独占所有；针对量表授权、使用、解释相关全部事宜，本公司享有最终解释权，受《中华人民共和国民法典》《中华人民共和国著作权法》《信息网络传播权保护条例》等法律法规完整保护。"
        ]
      },
      {
        "title": "二、侵权行为认定及禁止性规定",
        "body": [
          "本公司郑重作出法律警示：任何自然人、法人、非法人组织，未取得本公司加盖公章的正式书面授权许可，实施下列任一行为，均属于侵犯本公司著作权及相关知识产权的侵权行为，行为人应当依法承担停止侵害、赔偿损失等全部民事责任：",
          "除法律法规明确规定的合理使用情形外，未经许可复制、摘抄、扫描、翻拍、转录量表纸质或电子资料；",
          "通过社交社群、自媒体、网盘、网站、短视频平台等渠道公开发布、转发、无偿或有偿分发量表全部或节选内容；",
          "以营利或非盈利为目的，售卖、倒卖、租赁量表纸质版本、电子题库、计分工具、测评系统；",
          "擅自将量表用于临床测评、行业培训、课程教学、商业科普宣传、第三方科研外包等服务；",
          "篡改量表条目、私自复刻计分程序、仿制线上测评系统、改编配套解读材料；",
          "冒用本公司授权资质、商标、品牌对外开展量表相关合作、测评、培训业务。"
        ]
      },
      {
        "title": "三、非官方渠道资料免责条款",
        "body": [
          "凡自媒体、私人社群、无合作资质机构等非官方渠道流通、传播的量表试题、计分工具、解读材料、电子版测评材料，本公司不对其内容真实性、数据完整性、本土化常模效度、临床诊疗有效性、来源合法性作出任何明示或默示保证。任何主体使用前述盗版、非授权量表资料所造成的医疗误诊、临床评估结果偏差、科研数据失效、行业伦理失范、从业人员遭受监管处罚、人身权益损害、财产经济损失等全部不利后果，均由使用方自行独立承担全部责任。本公司已尽到事前侵权风险警示义务，不承担任何补充、连带、赔偿法律责任。"
        ]
      },
      {
        "title": "四、维权法律措施",
        "body": [
          "针对一切侵害本公司量表知识产权的侵权行为，本公司完整保留全部法定维权权利，可采取但不限于以下维权手段：",
          "向侵权主体发送律师催告函，要求立即停止侵权、销毁全部盗版资料、删除线上侵权内容；",
          "向著作权行政管理部门、市场监督管理部门提交书面投诉，申请行政查处；",
          "向有管辖权人民法院提起民事诉讼，主张侵权损害赔偿金、公证取证费、律师费、诉讼费、保全费等全部合理维权开支；",
          "对大规模批量盗版、以牟利为目的恶意侵权、造成重大经济损失的行为，同步移送公安机关，依法追究侵权主体行政、刑事法律责任。"
        ]
      },
      {
        "title": "五、合法使用规范提示",
        "body": [
          "各级医疗机构、高等院校、中小学、学前教育机构、心理咨询服务机构、科研单位及其他行业从业人员，如需合规使用本公司公开发行测评量表，须通过本公司官方渠道提交授权申请，签署正式书面使用许可合同，严格恪守中华人民共和国境内法律法规、行业伦理规范及合同全部约定条款，严禁转借、分许可或是以任何形式向第三方扩散量表全部配套资料，也不得超出授权合同约定的使用范围、使用期限、授权主体范围使用量表及相关资料。"
        ]
      },
      {
        "title": "六、官方对接渠道",
        "body": [
          "量表授权申请、侵权线索举报、声明条款法律咨询统一联络方式： 联系电话：0756-6883668 官方邮箱：info@gdhsyl.com.cn 通讯地址：珠海市高新区湾创路 88 号 A 栋 406 。",
          "本公司自收到符合我方要求的书面申请或真实有效侵权线索举报、与本声明及量表授权相关的完整法律咨询材料之日起，原则上30个自然日内完成核查予以正式答复。因案情复杂、需补充材料或不可抗力等特殊情况除外，对不符合要求的申请、举报、咨询，我方有权不予答复且无需说明理由。"
        ]
      },
      {
        "title": "七、法律效力与争议管辖补充条款",
        "body": [
          "本声明为本网站法定配套法律文件，与《网站使用条款》《个人信息保护政策》具有同等法律效力；三份文件内容存在冲突、歧义时，以本知识产权声明约定优先适用。",
          "本公司享有单方修订、增补、更新本声明内容的权利，修订完成后于本官网公示，新版本自公示之日即时生效；用户持续访问、使用本网站，即视为自愿接受最新版本全部条款约束。",
          "因本声明效力、量表知识产权权属、侵权纠纷产生的全部争议，适用中华人民共和国大陆地区现行有效法律；相关诉讼由本公司住所地有管辖权的人民法院管辖。",
          "更新日期：2026 年 6 月 30 日",
          "©2026 广东省华晟育林科技有限公司 保留全部知识产权，一切侵权行为必将依法追责"
        ]
      }
    ]
  },
  "termsPage": {
    "title": "使用条款",
    "intro": [
      "广东省华晟育林科技有限公司（以下统称 “华晟育林”，“我们”）提醒您：在使用本网站前，请您仔细阅读并理解本使用条款，本使用条款将构成您与华晟育林之间具有法律效力的规则。您可以选择不使用本网站，但如果您使用本网站，包括但不限于浏览本网站、在本网站留言、从本网站上传任何材料、数据、内容，以及以其他方式利用本网站，您的上述行为将被视为对本使用条款全部内容的同意。"
    ],
    "sections": [
      {
        "title": "1.总则",
        "body": [
          "本网站由华晟育林建设、维护和运营，并由华晟育林享有单独、完整的所有权及相关权益。本网站所有内容(包括不限于网页文本、设计、图片、配置以及其他内容)受华晟育林版权保护，未经华晟育林事先的书面同意，您不可以复印、复制、上载、及张贴等形式使用本网站及其中的任何内容进行创作及演绎创作其他作品。",
          "网站中所有相关注册商标以及华晟育林已经申请的商标为华晟育林所有，华晟育林对本网站的所有内容的版权、商标和其他专有权保留完整的所有权，未经华晟育林事先书面同意，您不得复制、模仿或使用。同时您接受该内容随附的任何条款、条件和声明，及本网站中的所有其他规定。如果本网站提供的其他软件或者信息有特殊使用规定，您也将受该特殊规定限制。"
        ]
      },
      {
        "title": "2.免责与赔偿条款",
        "body": [
          "本网站及其所包含的材料、信息、内容(包括数据、图像、声音、文本以及其他形式的信息)、服务、软件等(以下统称为“网站信息”)，由华晟育林或本网站用户提供。在法律法规允许范围内，本网站信息均以其现有状态提供，华晟育林对其不作任何明示或默示的担保。",
          "本网站及其所包含的信息可能包含技术性错误、漏洞或拼写、排版方面的错误，华晟育林不保证本网站及其所包含的信息的准确性和完整性，不保证本网站所包含的信息是最新的、适用于所有地区的，也不保证通过本网站展示或传播的任何评论、建议、观点、陈述及其他信息的可靠性。本网站及其所包含的信息的真实性、准确性和完整性、以及是否过期，应由您自行甄别并承担相应风险及责任。华晟育林可以根据独立的评估，在不进行通知的情况下，随时修改本网站的信息，包括但不限于显示数据、产品、程序、服务或者价格。华晟育林也不保证任何被告知或报告的问题将由华晟育林解决，即使华晟育林选择为了解决某个问题提供信息。该等信息仅供参考，不构成任何承诺或担保。",
          "华晟育林对于其产品和服务的责任受提供产品和服务所依据的特定协议规制。本网站上的任何内容都不能被解释为对该协议的更改、补充或组成部分，亦不构成要约。由于互联网超越国界的属性，并非所有本网站提及的产品或服务在您的国家或地区均被提供，请联系当地的华晟育林客户代表或经销商了解在您的国家或地区所提供的产品或服务。您亦可按照本网站提供的联系方式，直接与华晟育林联系。",
          "如果您下载或以其他方式获得本网站的数据、产品信息、软件、程序或服务信息，那么由您自行承担并负责可能产生的任何风险及损失，包括您信息处理系统的任何盈利损失、业务中断、信息、计划或其他数据的丢失。",
          "由于您在本网站上提交、发布或传递的任何信息、资料、数据或任何其他内容而产生纠纷，造成任何损失、责任、费用和开支(包括律师费、诉讼费以及一切其他费用)的，由您自行负责。华晟育林及其相关人员不对此担负任何责任，并有权向您追偿由此产生的一切直接及间接损失。前述情况下，华晟育林可基于法律法规所列举的收集和/或使用个人信息的同意例外透漏您的身份以及关于您的其他信息。"
        ]
      },
      {
        "title": "3.在本网站发布信息",
        "body": [
          "本网站为公共网站,不保证您在此提交的任何信息的保密性,请勿在此提交保密信息。若您仍提交保密信息的，视为您主动放弃对该等信息的保密权利，我方不承担任何保密责任。",
          "您应对通过本网站所提交的任何信息负责，包括信息的合法性、可靠性、适用性、原创性和版权所有。您不得通过本网站上传、发布以下内容:",
          "01.是秘密的、专有的、欺诈的、诽谤的、淫秽的、侵犯隐私或知识产权的信息;",
          "02.可能构成或者鼓励犯罪行为，甚至违反法律的内容;",
          "03.可能包含软件病毒、群发邮件或者任何形式的「垃圾邮件」;",
          "04.以任何形式干扰本网站其他用户的内容。",
          "华晟育林有权单方判定您提交的信息是否属于不可取、不适当或违反本使用条款的情形在不经过事先通知或取得您同意的情况下，自行决定编辑或删除信息且不承担任何责任。",
          "如果您提交了材料，表示您已确认授权华晟育林非限制地、非独占地、不可撤销地、永久地、无版权费地、全球地使用、复制、展示、修改、出版及传播该信息或资料并将前述权利转授权或许可第三方基于合法用途行使。并且，您也授权华晟育林无限制的、不可撤销的许可，华晟育林可以商业或非商业目的无偿使用您或代表您向华晟育林提交的任何想法、观念或技术。"
        ]
      },
      {
        "title": "4.链接",
        "body": [
          "为了给您提供方便，本网站为您提供了其他网站的链接，这些网站可能有自己的使用规则。为了您的利益，我们建议您先阅读这些网站的使用规则，华晟育林将不对这些链接网站的内容以及其运行负责，华晟育林不对您因使用任何链接造成的损失或侵害结果承担法律责任。",
          "除了华晟育林事先书面同意的以外，任何其他形式、针对本网站的所有链接必须经华晟育林书面批准，以获得链接到本网站的许可权，未经我方书面批准擅自链接至本网站的，我方有权采取屏蔽链接等措施，由此产生的全部损失由您承担；华晟育林可以随时自主决定终止链接到本网站的许可权。在这种情况下，您应立即移出到本网站的所有链接并停止使用任何华晟育林商业标识。"
        ]
      },
      {
        "title": "5.国际用户",
        "body": [
          "华晟育林不保证本网站的信息适用于中国(大陆)之外的其它地点。如果您从中国(大陆)之外的地点访问该网站，则您有责任遵守所有可适用的当地法律。"
        ]
      },
      {
        "title": "6.更新",
        "body": [
          "华晟育林保留单方修改、更新本规则的权利。对于任何重大修改，华晟育林将提前合理时间在本网站公布，并自公布后载明的生效日期起生效。您在本规则修改或更新后继续使用本网站，即构成您对修改或更新后的规则的认可。因此，建议您经常性地阅读本规则。"
        ]
      },
      {
        "title": "7.其他",
        "body": [
          "附加的或不同的条款、条件和声明可能适用于通过本网站提供的特定资料、信息、产品、软件和服务。如有任何冲突，此类附加的或不同的条款、条件和声明将优先于本使用规则适用。请参阅相应的协议或声明。",
          "在任何情况下，对本规则的任何部分未执行的，不视为华晟育林放弃该使用条款所赋予的权利。",
          "本使用规则应受中国法律(不包括台湾、香港、和澳门)约束，并按其解释。由本使用规则引起的任何纠纷，应当提交华晟育林住所地有管辖权的人民法院诉讼解决。",
          "本使用条款的解释权以及对本网站使用的解释权归于华晟育林。",
          "您违反本使用规则的，华晟育林有权单方终止或限制您使用本网站的全部或部分功能与服务；终止或限制通知送达您或在本网站公告发布之时生效。",
          "最近更新:2026年6月30日"
        ]
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/i18n/locales/zh/legal.js